import tippy from 'tippy.js';
import { deviceType } from 'detect-it';
import '../assets/css/tippy.css';

export default (Vue) => {
    return {
        async inserted(el, binding) {
            await Vue.nextTick();

            let options = {
                arrow: false,
                animation: 'translate',
                offset: [0, 5],
                showOnMobile: false,
                onlyOnTruncate: false,
                onShow(instance) {
                    return !!instance.props.content;
                },
            };

            if (typeof binding.value === 'object') {
                options = { ...options, ...binding.value };
            } else if (typeof binding.value === 'string') {
                options.content = binding.value;
            }

            if (!options.showOnMobile && deviceType === 'touchOnly') {
                return;
            }

            if (options.onlyOnTruncate && !(el.offsetWidth < el.scrollWidth)) {
                return;
            }

            delete options.showOnMobile;
            delete options.onlyOnTruncate;

            tippy(el, options);

            if (options.showOnLoad) {
                el._tippy.show();
            }
        },

        unbind(el) {
            if (!el._tippy) {
                return;
            }

            el._tippy.destroy();
        },

        componentUpdated(el, binding) {
            if (!el._tippy) {
                return;
            }

            let options = {};

            if (typeof binding.value === 'object') {
                options = { ...binding.value };
            } else if (typeof binding.value === 'string') {
                options.content = binding.value;
            }

            el._tippy.setProps(options);
        },
    };
};
